import { Inject, Injectable } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { forkJoin, from } from 'rxjs';

import { ON_BINGO_APP_INIT } from '../run-on-bingo-app.provider';

@Injectable()
export class BingoAppLazyBootstrapService {
    private isAlreadyBootstrapped = false;

    constructor(@Inject(ON_BINGO_APP_INIT) private initializers: OnAppInit[]) {}

    async onBingoAppInit(): Promise<any> {
        if (this.isAlreadyBootstrapped) {
            return;
        }
        const observables = this.initializers
            .map((initializer) => initializer.onAppInit())
            .filter((promise) => promise instanceof Promise)
            .map((promise) => from(promise));
        forkJoin(observables).subscribe();
        this.isAlreadyBootstrapped = true;
    }
}
